import angular from 'angular';
import { NsjRoutingType } from '../../../core/nsj-core';
import {
    IAfastamentosListagem,
    IFeriadosListagem,
    IFolgasListagem,
    IMudancaCalendarioItem,
} from './models/escala.model';

export interface IEventosCalendarioParams {
    datainicio: string;
    datafim: string;
    empresa: string;
    trabalhador_estabelecimento?: string;
}

export interface IEventosCalendario {
    folgas: IFolgasListagem[];
    folgasfixas: IFolgasListagem[];
    afastamentos: IAfastamentosListagem[];
    feriados: IFeriadosListagem[];
    lotacoes: IMudancaCalendarioItem[];
    horarios: IMudancaCalendarioItem[];
}

/**
 * Busca todos os eventos do calendário de um período numa requisição só
 * (folgas, folgas fixas, afastamentos, feriados e mudanças de lotação/horário).
 */
export class MeurhEscalaEventosService {

    static $inject = ['$http', 'nsjRouting'];

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: NsjRoutingType,
    ) {}

    carregar(params: IEventosCalendarioParams): angular.IPromise<IEventosCalendario> {
        return this.$http
            .get<IEventosCalendario>(this.nsjRouting.generate('meurh_calendario_eventos', { ...params }, true))
            .then((response) => response.data);
    }
}
